<template>
  <div id="SnippyError">
    <canvas class="zdog-canvas" width="500" height="500"></canvas>
  </div>
</template>

<script>
export default {
  name: "SnippyError",
  data: () => ({}),
  mounted() {
    // As an instance method inside a component
    this.$loadScript("https://unpkg.com/zdog@1/dist/zdog.dist.min.js")
    .then(() => {
      let isSpinning = false;
      var dark = "#22272B";
      var yellow = "#FFC845";
      var blue = "#56CCF2";
      var orange = "#DC582A";

      // Right
      let illo = new Zdog.Illustration({
        element: ".zdog-canvas",
        dragRotate: true,
        // stop spinning when drag starts
        onDragStart: function () {
          isSpinning = false;
        },
      });

      // head
      var head = new Zdog.Shape({
        addTo: illo,
        stroke: 200,
        color: blue,
      });

      let eye_left = new Zdog.Ellipse({
        addTo: head,
        width: 30,
        height: 55,
        stroke: 10,
        translate: { z: 95, x: -40 },
        color: dark,
      });

      let eye_left_pupil = new Zdog.Ellipse({
        addTo: eye_left,
        width: 20,
        height: 30,
        stroke: 10,
        fill: true,
        translate: { y: 10 },
        color: dark,
      });

      let eye_right = new Zdog.Ellipse({
        addTo: head,
        width: 30,
        height: 55,
        stroke: 10,
        translate: { z: 95, x: 40 },
        color: dark,
      });

      let eye_right_pupil = new Zdog.Ellipse({
        addTo: eye_right,
        width: 20,
        height: 30,
        stroke: 10,
        fill: true,
        translate: { y: 10 },
        color: dark,
      });

      let mouth = new Zdog.Ellipse({
        addTo: head,
        diameter: 30,
        stroke: 10,
        translate: { z: 95, y: 35 },
        color: dark,
        rotate: { z: 1.5 },
      });

      let body = new Zdog.Box({
        addTo: head,
        translate: { y: 250 },
        width: 140,
        height: 300,
        depth: 100,
        stroke: false,
        color: orange,
        fill: true,
        stroke: 1,
      });

      var arm_right = new Zdog.Shape({
        addTo: body,
        path: [
          { x: -20, y: -90, z: -20 }, // start at 1st point
          { x: 80, y: -220, z: -10 }, // line to 2nd point
          { x: 50, y: -290, z: 20 }, // line to 2nd point
        ],
        closed: false,
        stroke: 60,
        color: yellow,
        translate: { x: 80 },
      });

      var arm_left = new Zdog.Shape({
        addTo: body,
        path: [
          { x: 20, y: -90, z: -20 }, // start at 1st point
          { x: -80, y: -220, z: 10 }, // line to 2nd point
          { x: -50, y: -290, z: 20 }, // line to 2nd point
        ],
        closed: false,
        stroke: 60,
        color: yellow,
        translate: { x: -80 },
      });

      // global

      function animate() {
        illo.rotate.y += isSpinning ? 0.03 : 0;
        illo.updateRenderGraph();
        requestAnimationFrame(animate);
      }

      animate();
    });
  },
};
</script>

